import { MediaControlAction, MediaState } from './types'

export const getInitialState = (isPlaying: boolean = false): MediaState => ({
  bufferTime: 0,
  currentTime: 0,
  duration: 0,
  isPlaying: isPlaying,
  isMuted: false,
  videoPlayFromTime: 0,
  volume: 0.5,
})

export const reducer = (
  state: MediaState,
  action: MediaControlAction
): MediaState => {
  switch (action.type) {
    case 'changeVolume':
      return { ...state, isMuted: false, volume: action.payload }
    case 'setCurrentTime':
      return { ...state, currentTime: action.payload }
    case 'setVideoPlayFromTime':
      return { ...state, videoPlayFromTime: action.payload }
    case 'setDuration':
      return { ...state, duration: action.payload }
    case 'toggleMuted':
      return { ...state, isMuted: action.payload }
    case 'togglePlaying':
      return { ...state, isPlaying: action.payload }
    default:
      // @ts-expect-error Invalid type
      throw new Error(`No media control present: ${action.type}`)
  }
}
